import { html } from "lit-element";

export const menuIcon = html`
	<svg width="24" height="24" viewBox="0 0 24 24">
		<path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
	</svg>
`;
export const backIcon = html`
	<svg width="24" height="24" viewBox="0 0 24 24">
		<g><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" /></g>
	</svg>
`;
export const searchIcon = html`<svg viewBox="0 0 24 24"><g><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></path></g></svg>`;
export const accountIcon = html`
	<svg width="36" height="36" viewBox="0 0 24 24">
		<g>
			<path
				d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
			/>
		</g>
	</svg>
`;
export const favoriteIcon = html`
	<svg viewBox="0 0 24 24">
		<path d="M0 0h24v24H0z" fill="none" />
		<path
			d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
		/>
	</svg>
`;
export const favoriteBorderIcon = html`
	<svg viewBox="0 0 24 24">
		<path d="M0 0h24v24H0z" fill="none" />
		<path
			d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
		/>
	</svg>
`;
export const closeIcon = html`
	<svg viewBox="0 0 24 24">
		<path
			d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
		/>
		<path d="M0 0h24v24H0z" fill="none" />
	</svg>
`;

export const shopbasketIcon = html`
	<svg width="24" height="24" viewBox="0 0 32 32">
		<g>
			<path
				d="M29.438,11.2H21.427l-2.9,2.9a3.842,3.842,0,0,1-6.556-2.714c0-.062.016-.123.018-.186H2.56a.959.959,0,0,0-.96.96V16H30.4v-3.84a.961.961,0,0,0-.962-.96ZM17.229,12.8,25.317,4.71a.958.958,0,0,0,0-1.358L23.848,1.88a.965.965,0,0,0-1.36,0L14.4,9.97A2,2,0,0,0,17.229,12.8ZM6.117,27.634A1.606,1.606,0,0,0,7.6,28.8H24.4a1.608,1.608,0,0,0,1.483-1.166L28.32,17.6H3.68L6.117,27.634Z"
				transform="translate(-1.6 -1.6)"
			/>
		</g>
	</svg>
`;
export const shopIcon = html`
	<svg width="24" viewBox="0 0 32 32">
		<g>
			<path
				d="M9.8,11.6l1.266-8.4H4.481l-2.75,7.2a2.521,2.521,0,0,0-.13.8c0,1.766,1.84,3.2,4.114,3.2,2.1,0,3.829-1.222,4.083-2.8ZM16,14.4c2.272,0,4.114-1.434,4.114-3.2,0-.066,0-.131-.008-.194L19.292,3.2H12.71L11.894,11c0,.066-.006.131-.006.2,0,1.766,1.842,3.2,4.114,3.2Zm8,1.674V22.4H8V16.083a6.728,6.728,0,0,1-2.286.4A6.707,6.707,0,0,1,4.8,16.4V26.56A2.245,2.245,0,0,0,7.037,28.8H24.96a2.248,2.248,0,0,0,2.24-2.24V16.4a6.884,6.884,0,0,1-.914.078A6.657,6.657,0,0,1,24,16.073ZM30.272,10.4,27.518,3.2H20.937L22.2,11.587c.246,1.584,1.979,2.813,4.085,2.813,2.272,0,4.114-1.434,4.114-3.2A2.577,2.577,0,0,0,30.272,10.4Z"
				transform="translate(-1.601 -3.2)"
			/>
		</g>
	</svg>
`;
export const infoIcon = html`
	<svg width="24" viewBox="0 0 32 32">
		<g>
			<path
				d="M16,.64A15.361,15.361,0,1,0,31.36,16,15.361,15.361,0,0,0,16,.64Zm1.434,5.546a1.692,1.692,0,0,1,1.938,1.862,2.47,2.47,0,0,1-2.686,2.387c-1.418,0-2.093-.712-2.051-1.891a2.533,2.533,0,0,1,2.8-2.358ZM13.6,25.2c-1.024,0-1.771-.622-1.056-3.35l1.173-4.84c.2-.774.237-1.085,0-1.085A7.773,7.773,0,0,0,11.3,16.987l-.51-.837c2.488-2.078,5.349-3.3,6.573-3.3,1.024,0,1.194,1.21.683,3.072L16.7,21.012c-.238.9-.136,1.21.1,1.21a5.274,5.274,0,0,0,2.3-1.15l.579.778C17.258,24.269,14.62,25.2,13.6,25.2Z"
				transform="translate(-0.638 -0.64)"
			/>
		</g>
	</svg>
`;
export const userIcon = html`
	<svg width="24" viewBox="0 0 28 25.999">
		<g>
			<path
				d="M18,22.082V20.433A8.933,8.933,0,0,0,22,13c0-4.971,0-9-6-9s-6,4.029-6,9a8.931,8.931,0,0,0,4,7.432v1.649C7.216,22.637,2,25.97,2,30H30C30,25.97,24.784,22.636,18,22.082Z"
				transform="translate(-2 -4.001)"
			/>
		</g>
	</svg>
`;
export const trashIcon = html`
	<svg width="24" viewBox="0 0 24 32">
		<g>
			<path
				d="M5.422,11.381,7.184,28.834C7.282,29.572,10.843,32,16,32s8.722-2.429,8.818-3.166l1.763-17.453C23.887,12.888,19.859,13.6,16,13.6s-7.885-.712-10.578-2.219ZM21.069,2.416,19.695.894C19.164.137,18.588,0,17.466,0h-2.93c-1.12,0-1.7.138-2.227.894L10.935,2.416c-4.112.718-7.094,2.624-7.094,4.03v.272C3.841,9.193,9.286,11.2,16,11.2S28.163,9.194,28.163,6.718V6.446c0-1.406-2.981-3.312-7.093-4.03ZM19.312,6.944,17.6,4.8H14.4L12.691,6.944H9.971S12.95,3.39,13.349,2.909A1.223,1.223,0,0,1,14.367,2.4h3.269a1.223,1.223,0,0,1,1.019.509c.4.482,3.378,4.035,3.378,4.035h-2.72Z"
				transform="translate(-3.841)"
			/>
		</g>
	</svg>
`;
export const addUserIcon = html`
	<svg id="user-plus" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 32 32">
		<path
			d="M12,23a11.019,11.019,0,0,1,7.189-10.319A9.125,9.125,0,0,0,20,9c0-4.971,0-9-6-9S8,4.029,8,9a8.931,8.931,0,0,0,4,7.432v1.649C5.216,18.636,0,21.969,0,26H12.416A10.962,10.962,0,0,1,12,23Z"
		/>
		<path d="M23,14a9,9,0,1,0,9,9A9,9,0,0,0,23,14Zm5,10H24v4H22V24H18V22h4V18h2v4h4Z" />
	</svg>
`;
export const mailIcon = html`
	<svg
		width="24"
		aria-hidden="true"
		data-prefix="far"
		data-icon="envelope"
		role="img"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 512 512"
		class="svg-inline--fa fa-envelope fa-w-16 fa-9x"
	>
		<path
			fill="currentColor"
			d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
			class=""
		></path>
	</svg>
`;
export const editIcon = html`
	<svg
		width="24"
		aria-hidden="true"
		data-prefix="fas"
		data-icon="pen"
		role="img"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 512 512"
		class="svg-inline--fa fa-pen fa-w-16 fa-9x"
	>
		<path
			fill="currentColor"
			d="M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
			class=""
		></path>
	</svg>
`;
export const eyeIcon = html`
	<svg
		width="24"
		aria-hidden="true"
		data-prefix="fas"
		data-icon="eye"
		role="img"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 576 512"
		class="svg-inline--fa fa-eye fa-w-18 fa-9x"
	>
		<path
			fill="currentColor"
			d="M569.354 231.631C512.969 135.949 407.81 72 288 72 168.14 72 63.004 135.994 6.646 231.631a47.999 47.999 0 0 0 0 48.739C63.031 376.051 168.19 440 288 440c119.86 0 224.996-63.994 281.354-159.631a47.997 47.997 0 0 0 0-48.738zM288 392c-75.162 0-136-60.827-136-136 0-75.162 60.826-136 136-136 75.162 0 136 60.826 136 136 0 75.162-60.826 136-136 136zm104-136c0 57.438-46.562 104-104 104s-104-46.562-104-104c0-17.708 4.431-34.379 12.236-48.973l-.001.032c0 23.651 19.173 42.823 42.824 42.823s42.824-19.173 42.824-42.823c0-23.651-19.173-42.824-42.824-42.824l-.032.001C253.621 156.431 270.292 152 288 152c57.438 0 104 46.562 104 104z"
			class=""
		></path>
	</svg>
`;
export const cloudUploadIcon = html`
	<svg
		width="24"
		aria-hidden="true"
		data-prefix="fas"
		data-icon="cloud-upload-alt"
		role="img"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 640 512"
		class="svg-inline--fa fa-cloud-upload-alt fa-w-20 fa-9x"
	>
		<path
			fill="currentColor"
			d="M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
			class=""
		></path>
	</svg>
`;

// Icomoon
export const calanderIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 32">
		<path
			d="M10,12h4v4H10Zm6,0h4v4H16Zm6,0h4v4H22ZM4,24H8v4H4Zm6,0h4v4H10Zm6,0h4v4H16Zm-6-6h4v4H10Zm6,0h4v4H16Zm6,0h4v4H22ZM4,18H8v4H4ZM26,0V2H22V0H8V2H4V0H0V32H30V0Zm2,30H2V8H28Z"
		/>
	</svg>
`;
export const creditcardIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
		<path
			d="M29,4H3A3.009,3.009,0,0,0,0,7V25a3.009,3.009,0,0,0,3,3H29a3.009,3.009,0,0,0,3-3V7A3.009,3.009,0,0,0,29,4ZM3,6H29a1.013,1.013,0,0,1,1,1v3H2V7A1.013,1.013,0,0,1,3,6ZM29,26H3a1.013,1.013,0,0,1-1-1V16H30v9A1.013,1.013,0,0,1,29,26ZM4,20H6v4H4Zm4,0h2v4H8Zm4,0h2v4H12Z"
			transform="translate(0 -4)"
		/>
	</svg>
`;
export const profileCardIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 32">
		<path
			d="M27,0H3A3.009,3.009,0,0,0,0,3V29a3.009,3.009,0,0,0,3,3H27a3.009,3.009,0,0,0,3-3V3A3.009,3.009,0,0,0,27,0ZM26,28H4V4H26ZM8,18H22v2H8Zm0,4H22v2H8ZM10,9a3,3,0,1,1,3,3A3,3,0,0,1,10,9Zm5,3H11c-1.65,0-3,.9-3,2v2H18V14C18,12.9,16.65,12,15,12Z"
		/>
	</svg>
`;
export const addProfileCardIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.001 37">
		<g transform="translate(-19.999 -622)">
			<path
				d="M7538.289-1903H7525a3,3,0,0,1-3-3v-26a3,3,0,0,1,3-3h24a3,3,0,0,1,3,3v15.289a10.435,10.435,0,0,0-4-.789V-1931h-22v24h11.5a10.437,10.437,0,0,0,.789,4Zm0-8H7530v-2h9.381a10.449,10.449,0,0,0-1.094,2Zm2.911-4H7530v-2h14v.288a10.493,10.493,0,0,0-2.8,1.711Zm-1.2-4h-10v-2c0-1.1,1.345-2,3-2h2a3,3,0,0,1-3-3,3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3h2c1.654,0,3,.9,3,2v2Z"
				transform="translate(-7502 2557)"
			/>
			<path
				d="M23,14a9,9,0,1,0,9,9A9,9,0,0,0,23,14Zm5,10H24v4H22V24H18V22h4V18h2v4h4Z"
				transform="translate(23 627)"
			/>
		</g>
	</svg>
`;
export const tilesIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.609 13.61">
		<g transform="translate(-12227 -5274)">
			<rect width="3.888" height="3.888" transform="translate(12227 5283.721)" />
			<rect width="3.888" height="3.888" transform="translate(12231.86 5283.721)" />
			<rect width="3.888" height="3.888" transform="translate(12236.721 5283.721)" />
			<rect width="3.888" height="3.888" transform="translate(12227 5278.86)" />
			<rect width="3.888" height="3.888" transform="translate(12231.86 5278.86)" />
			<rect width="3.888" height="3.888" transform="translate(12236.721 5278.86)" />
			<rect width="3.888" height="3.888" transform="translate(12227 5274)" />
			<rect width="3.888" height="3.888" transform="translate(12231.86 5274)" />
			<rect width="3.888" height="3.888" transform="translate(12236.721 5274)" />
		</g>
	</svg>
`;

export const fileText2Icon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 32">
		<g transform="translate(-2)">
			<path
				d="M28.681,7.159a28.385,28.385,0,0,0-2.724-3.116,28.187,28.187,0,0,0-3.116-2.724C21.229.137,20.448,0,20,0H4.5A2.5,2.5,0,0,0,2,2.5v27A2.5,2.5,0,0,0,4.5,32h23A2.5,2.5,0,0,0,30,29.5V10c0-.448-.137-1.23-1.319-2.841Zm-4.138-1.7A27.334,27.334,0,0,1,26.811,8H22V3.189A27.334,27.334,0,0,1,24.543,5.457ZM28,29.5a.507.507,0,0,1-.5.5H4.5a.507.507,0,0,1-.5-.5V2.5A.507.507,0,0,1,4.5,2H20V9a1,1,0,0,0,1,1h7Z"
			/>
			<path d="M23,26H9a1,1,0,0,1,0-2H23a1,1,0,0,1,0,2Z" />
			<path d="M23,22H9a1,1,0,0,1,0-2H23a1,1,0,0,1,0,2Z" />
			<path d="M23,18H9a1,1,0,0,1,0-2H23a1,1,0,0,1,0,2Z" />
		</g>
	</svg>
`;
export const earthIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
		<path
			d="M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,30a13.959,13.959,0,0,1-5.538-1.139l7.286-8.2A1,1,0,0,0,18,20V17a1,1,0,0,0-1-1c-3.531,0-7.256-3.671-7.293-3.707A1,1,0,0,0,9,12H5a1,1,0,0,0-1,1v6a1,1,0,0,0,.553.894L8,21.618v5.871A14.008,14.008,0,0,1,3.349,10H7a1,1,0,0,0,.707-.293l4-4A1,1,0,0,0,12,5V2.581a14.041,14.041,0,0,1,10.134.831c-.13.109-.256.224-.376.345A6,6,0,0,0,26,14c.1,0,.2,0,.3-.007a23.475,23.475,0,0,1-.263,11.635.936.936,0,0,0-.026.163A13.956,13.956,0,0,1,16,30Z"
		/>
	</svg>
`;
export const statsDotsIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
		<path
			id="stats-dots"
			class="cls-1"
			d="M4,28H32v4H0V0H4Zm5-2a3,3,0,0,1,0-6c.088,0,.176,0,.262.012l3.225-5.375a3,3,0,1,1,5.026,0l3.225,5.375C20.824,20,20.912,20,21,20c.067,0,.133,0,.2.007l5.324-9.316A3,3,0,1,1,29,12c-.067,0-.133,0-.2-.007l-5.324,9.316a3,3,0,1,1-4.991.053l-3.225-5.375c-.086.007-.174.012-.262.012s-.176-.005-.262-.012l-3.225,5.375A3,3,0,0,1,9,26Z"
		/>
	</svg>
`;
export const wrenchIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 31.999">
		<path
			id="wrench"
			class="cls-1"
			d="M31.342,25.559,16.95,13.223A9,9,0,0,0,6.387.387l5.2,5.2a2.005,2.005,0,0,1,0,2.828L8.415,11.587a2.005,2.005,0,0,1-2.828,0l-5.2-5.2A9,9,0,0,0,13.223,16.95L25.559,31.342a1.828,1.828,0,0,0,2.716.1l3.172-3.172a1.828,1.828,0,0,0-.1-2.716Z"
			transform="translate(-0.001 -0.001)"
		/>
	</svg>
`;
export const trophyIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 28">
		<path
			d="M26,6V2H6V6H0v4a6,6,0,0,0,7.8,5.725A10.006,10.006,0,0,0,14,19.8V26H12a4,4,0,0,0-4,4H24a4,4,0,0,0-4-4H18V19.8a10.006,10.006,0,0,0,6.2-4.075A6,6,0,0,0,32,10V6H26ZM6,13.625A3.629,3.629,0,0,1,2.375,10V8H6v2a9.972,9.972,0,0,0,.655,3.565,3.627,3.627,0,0,1-.655.06ZM29.625,10a3.623,3.623,0,0,1-4.28,3.565A9.968,9.968,0,0,0,26,10V8h3.625Z"
			transform="translate(0 -2)"
		/>
	</svg>
`;
export const powerIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M12,0,0,16H12L4,32,32,12H16L28,0Z" /></svg>
`;
export const bubblesIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 31.985">
		<path
			d="M34,28.161a3.649,3.649,0,0,0,2,3.256v.5a7.559,7.559,0,0,1-1.016.07,7.42,7.42,0,0,1-5.4-2.321A10.056,10.056,0,0,1,27,30c-4.971,0-9-3.582-9-8s4.029-8,9-8,9,3.582,9,8a7.385,7.385,0,0,1-1.667,4.64A3.635,3.635,0,0,0,34,28.162ZM16,0c8.7,0,15.781,5.644,15.995,12.672A12.262,12.262,0,0,0,27,11.625a11.909,11.909,0,0,0-7.942,2.943A9.872,9.872,0,0,0,15.625,22a9.577,9.577,0,0,0,.867,3.993C16.329,26,16.165,26,16,26a19.66,19.66,0,0,1-2.495-.158C10.068,29.279,5.966,29.895,2,29.986v-.841C4.142,28.1,6,26.184,6,24a6.032,6.032,0,0,0-.068-.9C2.313,20.72,0,17.079,0,13,0,5.82,7.163,0,16,0Z"
		/>
	</svg>
`;
export const usersIcon = html`
	<svg width="24" id="users" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 32">
		<path
			d="M24,24.082V22.433A8.933,8.933,0,0,0,28,15c0-4.971,0-9-6-9s-6,4.029-6,9a8.931,8.931,0,0,0,4,7.432v1.649C13.216,24.637,8,27.97,8,32H36C36,27.97,30.784,24.636,24,24.082Z"
		/>
		<path
			d="M10.225,24.854a18.981,18.981,0,0,1,6.243-2.513A11.329,11.329,0,0,1,15.2,20.5,11.458,11.458,0,0,1,13.75,15c0-2.689,0-5.228.956-7.3a6.512,6.512,0,0,1,4.976-3.734C19.153,1.571,17.746,0,14,0,8,0,8,4.029,8,9a8.931,8.931,0,0,0,4,7.432v1.649C5.216,18.636,0,21.969,0,26H8.719a12.828,12.828,0,0,1,1.506-1.146Z"
		/>
	</svg>
`;
export const filterIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
		<path
			d="M16,0C7.163,0,0,2.239,0,5V8L12,20V30c0,1.1,1.791,2,4,2s4-.9,4-2V20L32,8V5C32,2.239,24.837,0,16,0ZM2.95,4.338A13.558,13.558,0,0,1,5.99,3.167,39.458,39.458,0,0,1,16,2,39.419,39.419,0,0,1,26.012,3.167a13.655,13.655,0,0,1,3.04,1.171A3.434,3.434,0,0,1,29.936,5a3.5,3.5,0,0,1-.884.662,13.578,13.578,0,0,1-3.04,1.171A39.458,39.458,0,0,1,16,8,39.419,39.419,0,0,1,5.99,6.833,13.675,13.675,0,0,1,2.95,5.662,3.458,3.458,0,0,1,2.066,5a3.5,3.5,0,0,1,.884-.662Z"
		/>
	</svg>
`;

export const arrowUpIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.559 10.88">
		<path
			d="M24.774,19.923a1.7,1.7,0,0,1-2.522,0L16,13.928,9.746,19.923a1.7,1.7,0,0,1-2.518,0,1.9,1.9,0,0,1,0-2.584c.65-.669,7.512-7.2,7.512-7.2a1.75,1.75,0,0,1,2.521,0s6.859,6.534,7.512,7.2a1.9,1.9,0,0,1,0,2.584Z"
			transform="translate(-6.722 -9.6)"
		/>
	</svg>
`;
export const arrowDownIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.559 10.88">
		<path
			d="M7.226,12.077a1.7,1.7,0,0,1,2.522,0L16,18.072l6.253-5.995a1.7,1.7,0,0,1,2.518,0,1.9,1.9,0,0,1,0,2.584c-.65.669-7.512,7.2-7.512,7.2a1.75,1.75,0,0,1-2.521,0s-6.859-6.534-7.512-7.2a1.9,1.9,0,0,1,0-2.584Z"
			transform="translate(-6.72 -11.52)"
		/>
	</svg>
`;
export const circleFireIcon = html`
	<svg width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22.002">
		<g transform="translate(-1297 -219.999)">
			<path
				d="M-15871-10288a11.013,11.013,0,0,1-11-11,11.013,11.013,0,0,1,11-11,11.013,11.013,0,0,1,11,11A11.013,11.013,0,0,1-15871-10288Zm.5-12.023a5.266,5.266,0,0,1,1.641,6.424c1.9-1.077,2.919-2.432,3.013-4.026a6.764,6.764,0,0,0-2.318-4.878,1.832,1.832,0,0,1-.212,1.98,6.485,6.485,0,0,0-1.859-3.263,3.711,3.711,0,0,0-1.2-.759c.205,1.383-.5,3.068-2.081,5.01a3.678,3.678,0,0,0-.444-1.813,5.167,5.167,0,0,1-.665,1.921l0,.01a6.627,6.627,0,0,0-.623,1.577,3.045,3.045,0,0,0,.291,2.262,5.844,5.844,0,0,0,2.29,1.977l.006,0-.007,0a2.8,2.8,0,0,1,.222-3.206,5.194,5.194,0,0,0,.773-1.783v0l0,0a2.163,2.163,0,0,1,.286,1.606A4.066,4.066,0,0,0-15870.5-10300.022Z"
				transform="translate(17179 10530)"
			/>
		</g>
	</svg>
`;
export const circleCheckIcon = html`
	<svg width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22.002">
		<path
			d="M-15871-10288a11.013,11.013,0,0,1-11-11,11.013,11.013,0,0,1,11-11,11.013,11.013,0,0,1,11,11A11.013,11.013,0,0,1-15871-10288Zm-3.35-12.417h0l-1.71,1.71,4.105,4.105,6.84-6.84-1.71-1.71-5.13,5.13-2.4-2.4Z"
			transform="translate(15882 10310.001)"
		/>
	</svg>
`;
export const crossIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.001 32.001">
		<path
			d="M31.708,25.708h0L22,16l9.708-9.708h0a1,1,0,0,0,0-1.414L27.122.292a1,1,0,0,0-1.414,0h0L16,10,6.292.291h0a1,1,0,0,0-1.414,0L.292,4.878a1,1,0,0,0,0,1.414h0L10,16,.292,25.708h0a1.014,1.014,0,0,0-.229.357,1,1,0,0,0,.229,1.057l4.586,4.586a1,1,0,0,0,1.414,0h0L16,22l9.708,9.708h0a1,1,0,0,0,1.414,0l4.586-4.586a1,1,0,0,0,0-1.414Z"
			transform="translate(0 0)"
		/>
	</svg>
`;
export const flopyDiskIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
		<path d="M28,0H0V32H32V4ZM16,4h4v8H16ZM28,28H4V4H6V14H24V4h2.343L28,5.657Z" />
	</svg>
`;
export const pencilIcon = html`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
		<path
			d="M27,0a5,5,0,0,1,4,8l-2,2L22,3l2-2A4.976,4.976,0,0,1,27,0ZM2,23,0,32l9-2L27.5,11.5l-7-7ZM22.362,11.362l-14,14L6.638,23.638l14-14Z"
		/>
	</svg>
`;
export const binIcon = html`
	<svg width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 32">
		<g transform="translate(-2)">
			<path
				d="M4,10V30a2.006,2.006,0,0,0,2,2H24a2.006,2.006,0,0,0,2-2V10Zm6,18H8V14h2Zm4,0H12V14h2Zm4,0H16V14h2Zm4,0H20V14h2Z"
			/>
			<path
				d="M26.5,4H20V1.5A1.5,1.5,0,0,0,18.5,0h-7A1.5,1.5,0,0,0,10,1.5V4H3.5A1.5,1.5,0,0,0,2,5.5V8H28V5.5A1.5,1.5,0,0,0,26.5,4ZM18,4H12V2.025h6Z"
			/>
		</g>
	</svg>
`;
export const squareRightIcon = html`
	<svg
		width="24"
		aria-hidden="true"
		data-prefix="far"
		data-icon="caret-square-right"
		role="img"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 448 512"
		class="svg-inline--fa fa-caret-square-right fa-w-14 fa-9x"
	>
		<path
			fill="currentColor"
			d="M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
			class=""
		></path>
	</svg>
`;
export const squareLeftIcon = html`
	<svg
		width="24"
		aria-hidden="true"
		data-prefix="far"
		data-icon="caret-square-left"
		role="img"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 448 512"
		class="svg-inline--fa fa-caret-square-left fa-w-14 fa-7x"
	>
		<path
			fill="currentColor"
			d="M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
			class=""
		></path>
	</svg>
`;

// Line
export const lineEmail = html`
	<svg width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.31 22.102">
		<path
			d="M65.854,122.093l.028-.007.026-.007.026-.009.026-.01.024-.011.027-.013.021-.013.026-.016.021-.016.023-.017.029-.026.012-.011.011-.012.026-.029.018-.024.015-.02.017-.028.012-.02.013-.028.01-.022c0-.009.007-.018.01-.027s.006-.017.009-.025,0-.018.007-.028,0-.017.006-.026,0-.022,0-.032,0-.015,0-.022,0-.038,0-.056V100.57c0-.006,0-.013,0-.019s0-.022,0-.033,0-.017,0-.026,0-.019,0-.029,0-.018-.006-.027,0-.018-.007-.027l-.009-.026-.01-.026-.011-.024-.013-.026-.013-.023-.015-.025-.016-.023-.016-.022-.02-.023-.013-.015,0,0-.024-.022-.018-.016-.023-.017-.022-.017-.02-.012-.028-.017-.019-.009-.03-.015-.027-.01-.024-.009-.028-.007-.026-.007-.024,0-.032,0h-.02l-.036,0H35.562l-.035,0h-.021l-.031,0-.024,0-.025.007-.028.007-.023.008-.029.011-.029.014-.021.01-.026.016-.021.013-.021.015-.024.018-.017.015-.025.024,0,0-.012.014-.022.025-.016.021-.017.024-.014.024-.014.024-.012.025-.011.025-.009.026c0,.009-.006.018-.009.027s0,.017-.007.026,0,.018-.006.027,0,.019,0,.028,0,.017,0,.026,0,.021,0,.032,0,.013,0,.019v20.968c0,.019,0,.038,0,.056s0,.016,0,.024,0,.021,0,.031,0,.018.007.027,0,.018.007.026.006.018.009.027.006.017.009.026l.011.024.013.026.013.022.015.025.017.023.016.021c.011.013.022.026.034.038l0,0,0,0c.012.012.024.023.037.033l.021.016.024.017.025.015.023.013.026.012.025.011.025.009.027.01.026.007.028.007.03,0,.025,0,.056,0H65.743l.056,0,.025,0ZM36.133,101.906l9.284,8.979-9.284,9.284Zm14.522,12.468L36.968,101.136H64.342Zm-4.423-2.7,4.029,3.9.016.014.02.018.024.018.022.015.026.016.022.013.028.013.022.01.031.011.021.007.034.008.019,0,.038.006.016,0,.054,0h0l.054,0,.016,0,.038-.006.02,0,.033-.008.022-.007.03-.011.022-.01.028-.013.023-.013.025-.015.022-.016.024-.018.021-.018.016-.014,4.029-3.9,9.3,9.3H36.935Zm9.66-.788,9.284-8.979v18.263Z"
			transform="translate(-35 -100.003)"
		/>
	</svg>
`;
export const lineUser = html`
	<svg width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.143 35.105">
		<defs>
			<style>
				.cls-1,
				.cls-3 {
					fill: none;
				}
				.cls-1 {
					stroke: #3c3b54;
					stroke-width: 1.3px;
				}
				.cls-2 {
					stroke: none;
				}
			</style>
		</defs>
		<g transform="translate(-1155.373 -379.229)">
			<path
				class="cls-1"
				d="M15933.5,8345.742c-3.58-9.57-8.476-9.907-16.761-9.795-8.266.112-11.538,9.795-11.538,9.795Z"
				transform="translate(-14748.922 -7932.058)"
			/>
			<g class="cls-1" transform="translate(1161.984 379.229)">
				<rect class="cls-2" width="17.255" height="19.72" rx="8.627" />
				<rect class="cls-3" x="0.65" y="0.65" width="15.955" height="18.42" rx="7.977" />
			</g>
		</g>
	</svg>
`;
export const lineLock = html`
	<svg width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.833 31.222">
		<defs>
			<style>
				.icon-line-lock {
					fill: none;
					stroke: #3c3b54;
					stroke-miterlimit: 10;
					stroke-width: 1.3px;
				}
			</style>
		</defs>
		<g id="lock-style-circle-line-content-icon" transform="translate(0.65 0.649)">
			<g transform="translate(0 0)">
				<path
					class="icon-line-lock"
					d="M150.633,218.5H125.1v14.337a4.287,4.287,0,0,0,4.281,4.281h16.97a4.287,4.287,0,0,0,4.282-4.281Z"
					transform="translate(-125.1 -207.196)"
				/>
				<path
					class="icon-line-lock"
					d="M184.143,113.9s2-11.3-8.192-11.3c-10.582,0-8.719,11.3-8.719,11.3"
					transform="translate(-163.008 -102.6)"
				/>
			</g>
			<path
				class="icon-line-lock"
				d="M235.893,265.8a2.9,2.9,0,1,0-4.535,2.389v3.15h3.267v-3.16A2.812,2.812,0,0,0,235.893,265.8Z"
				transform="translate(-219.859 -247.266)"
			/>
		</g>
	</svg>
`;

export const swiDatastudioBubble = {
	prefix: "swi",
	iconName: "datastudio-bubble",
	icon: [
		32,
		32,
		[],
		null,
		"M6.6,26.3C3,26.3,0,23.3,0,19.7s2.9-6.5,6.6-6.5s6.5,2.9,6.5,6.5S10.2,26.3,6.6,26.3z M6.6,15.7 c-2.3,0-4.1,1.8-4.1,4c0,2.2,1.9,4,4.1,4s4-1.9,4-4C10.6,17.4,8.9,15.7,6.6,15.7z M19.8,24.8c-2.7,0-5-2.3-5-5c0-2.7,2.2-5,5-5 c2.7,0,5,2.3,5,5S22.5,24.8,19.8,24.8z M19.8,17.3c-1.4,0-2.5,1.1-2.5,2.5c0,1.3,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5 S21.1,17.3,19.8,17.3z M19.8,13.1c-3.6,0-6.5-2.9-6.5-6.5S16.2,0,19.8,0s6.5,2.9,6.5,6.6S23.4,13.1,19.8,13.1z M19.8,2.5 c-2.3,0-4,1.8-4,4.1c0,2.2,1.9,4,4,4s4-1.9,4-4C23.8,4.3,22.1,2.5,19.8,2.5z M6.6,9.8c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3 s3.3,1.5,3.3,3.3S8.4,9.8,6.6,9.8z M6.6,5.8c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8S7,5.8,6.6,5.8z"
	]
};
export const swiDatastudioBar = {
	prefix: "swi",
	iconName: "datastudio-bar",
	icon: [
		28,
		28,
		[],
		null,
		"M27.1,28H1.3C0.6,28,0,27.5,0,26.8s0.6-1.3,1.3-1.3h25.8c0.7,0,1.3,0.6,1.3,1.3S27.8,28,27.1,28z M25.3,24.7 c-0.7,0-1.3-0.6-1.3-1.3V3.6h-4.4v19.8c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3V13h-5.8v10c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3 V2.5H4.5v20.4c0,0.7-0.6,1.3-1.3,1.3S2,23.6,2,22.9V0h9.4v10.4h5.8V1.1h9.4v22.3C26.5,24.1,26,24.7,25.3,24.7z"
	]
};
export const swiDatastudioBarVertical = {
	prefix: "swi",
	iconName: "datastudio-bar-vertical",
	icon: [
		32,
		32,
		[],
		null,
		"M1.2,28.3c-0.7,0-1.3-0.6-1.3-1.3V1.3C0,0.6,0.5,0,1.2,0s1.3,0.6,1.3,1.3v25.8C2.5,27.8,1.9,28.3,1.2,28.3z M25.6,26.5h-21c-0.7,0-1.3-0.6-1.3-1.3S3.9,24,4.6,24h19.7v-4.4H4.6c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3H15v-5.8H5.1 c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3h20.4V4.5H5.1c-0.7,0-1.3-0.6-1.3-1.3S4.4,2,5.1,2h21.6C27.4,2,28,2.5,28,3.2v6.9 c0,0.7-0.6,1.3-1.3,1.3h-9.2v5.8h8c0.7,0,1.3,0.6,1.3,1.3v6.9C26.8,26,26.3,26.5,25.6,26.5z"
	]
};
export const swiDatastudioTable = {
	prefix: "swi",
	iconName: "datastudio-table",
	icon: [
		32,
		24,
		[],
		null,
		"M26.3,23H6c-3.3,0-6-2.7-6-6V6c0.1-3.4,2.8-6,6-6h20.3c3.3,0,6,2.7,6,6.1v10.8C32.3,20.2,29.6,23,26.3,23z M17.5,20.5h8.8c2,0,3.5-1.6,3.5-3.5v-0.5H17.5V20.5z M2.5,16.5v0.5c0,2,1.6,3.5,3.5,3.5h9v-4H2.5z M17.5,14h12.3V9.5H17.5V14z M2.4,14H15V9.5H2.4V14z M17.5,7h12.3V6.1c0-2-1.6-3.6-3.5-3.6h-8.8V7z M2.4,7H15V2.5H6C4.1,2.5,2.5,4.1,2.4,6V7z"
	]
};
export const swiDatastudioLine = {
	prefix: "swi",
	iconName: "datastudio-line",
	icon: [
		30,
		30,
		[],
		null,
		"M29.3,30.3h-28c-0.7,0-1.3-0.6-1.3-1.3V1.2C0,0.5,0.6,0,1.3,0s1.3,0.6,1.3,1.3v26.6h26.8 c0.7,0,1.3,0.6,1.3,1.3S30,30.3,29.3,30.3z M26.3,26.7H5.1c-0.7,0-1.3-0.6-1.3-1.3V10.9c0-0.3,0.1-0.6,0.3-0.8L8,5.5 C8.3,5.2,8.6,5.1,9,5c0.4,0,0.7,0.2,1,0.5l6.5,8.1l3.1-2.9c0.5-0.5,1.3-0.4,1.8,0.1l5.9,6.2c0.2,0.2,0.3,0.5,0.3,0.9v7.6 C27.5,26.1,27,26.7,26.3,26.7z M6.4,24.2H25v-5.9l-4.7-4.9l-3.2,3c-0.3,0.2-0.6,0.4-0.9,0.3c-0.3,0-0.7-0.2-0.9-0.5L9,8.3l-2.6,3.1 V24.2z"
	]
};
export const swiDatastudioSpider = {
	prefix: "swi",
	iconName: "datastudio-spider",
	icon: [
		32,
		32,
		[],
		null,
		"M24.2,30c-0.4,0-0.8-0.2-1-0.5L20.8,26l-9.4-1.2l-2.4,3.4c-0.4,0.6-1.2,0.7-1.7,0.3c-0.6-0.4-0.7-1.2-0.3-1.7 l2.6-3.6c0,0,0,0,0,0l-3.7-6.4c0,0-0.1,0-0.1,0l-4.5-0.1c-0.7,0-1.2-0.6-1.2-1.3c0-0.7,0.6-1.3,1.3-1.2l4.5,0.1c0,0,0,0,0,0 l3.7-8.6L7.6,1.9C7.3,1.3,7.5,0.5,8.1,0.2c0.6-0.3,1.4-0.1,1.7,0.5l1.9,3.7L20,5.6l1.7-4c0.3-0.6,1-0.9,1.6-0.7s0.9,1,0.7,1.6 l-1.7,4.1c0,0,0,0,0,0l5.6,7.4l3.5,0.1c0.7,0,1.2,0.6,1.2,1.3c0,0.7-0.6,1.2-1.2,1.2c0,0,0,0,0,0l-3.6-0.1l-4.6,8.3l2.2,3.2 c0.4,0.6,0.2,1.3-0.3,1.7C24.7,30,24.4,30,24.2,30z M12,22.3l9,1.2l4.6-8.3l-5.3-7l-8.6-1.3L8,15.4L12,22.3z"
	]
};

export const swiDatastudioKpi = {
	prefix: "swi",
	iconName: "datastudio-kpi",
	icon: [
		27,
		21,
		[],
		null,
		"M22,21H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h17c2.8,0,5,2.2,5,5v11C27,18.8,24.8,21,22,21z M5,2.5 C3.6,2.5,2.5,3.6,2.5,5v11c0,1.4,1.1,2.5,2.5,2.5h17c1.4,0,2.5-1.1,2.5-2.5V5c0-1.4-1.1-2.5-2.5-2.5H5z M14,12.3 c0,0.8-0.5,1.6-1.2,2l-0.4-0.5c0.3-0.2,0.5-0.5,0.6-0.9c-0.4-0.1-0.6-0.3-0.6-0.7c0-0.5,0.3-0.8,0.8-0.8C13.7,11.4,14,11.7,14,12.3z M7.1,12.9c0-2.4,2.6-2.9,2.6-3.5c0-0.2-0.2-0.4-0.4-0.5c0,0,0,0-0.1,0c-0.2,0-0.4,0.1-0.5,0.2C8.5,9.3,8.3,9.4,8,9.2L7.5,8.8 C7.3,8.7,7.2,8.4,7.3,8.1c0,0,0-0.1,0.1-0.1c0.5-0.6,1.3-1,2.1-1c1.1-0.1,2.2,0.7,2.3,1.9c0,0.1,0,0.1,0,0.2c0,2-2.4,2.4-2.5,2.9h2 c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0.1,0,0.1v0.4c0,0.3-0.2,0.6-0.5,0.6c0,0-0.1,0-0.1,0H7.8c-0.3,0-0.6-0.2-0.6-0.5c0,0,0-0.1,0-0.1 V12.9L7.1,12.9z M15.1,12.6c0-0.3,0.2-0.6,0.5-0.6c0,0,0.1,0,0.1,0h0.8v-2c0-0.3,0-0.5,0-0.5h0c0,0.1-0.1,0.1-0.1,0.2 c-0.2,0.2-0.5,0.2-0.7,0c0,0,0,0-0.1-0.1l-0.3-0.3C15,9.1,15,8.8,15.2,8.5c0,0,0.1-0.1,0.1-0.1l1.1-1c0.2-0.2,0.5-0.3,0.7-0.3h0.6 c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0.1,0,0.1V12h0.8c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0.1,0,0.1v0.5c0,0.3-0.2,0.6-0.5,0.6c0,0-0.1,0-0.1,0 h-3.4c-0.3,0-0.6-0.2-0.6-0.5c0,0,0-0.1,0-0.1L15.1,12.6L15.1,12.6z"
	]
};

export const swiDatastudioPie = {
	prefix: "swi",
	iconName: "datastudio-pie",
	icon: [
		28,
		28,
		[],
		null,
		"M23.7,13.3h-10v-10c0-0.7-0.6-1.3-1.3-1.3C5.6,2,0,7.6,0,14.5c0,0,0,0,0,0c0,0,0,0,0,0C0,21.5,5.6,27,12.5,27 c0.2,0,0.3,0,0.5-0.1c6.6-0.3,12-5.7,12-12.4C25,13.8,24.4,13.3,23.7,13.3z M12.5,24.5c-0.2,0-0.3,0-0.4,0.1 c-5.3-0.2-9.5-4.6-9.5-9.9c0,0,0,0,0,0c0,0,0,0,0,0c0-5.1,3.8-9.3,8.7-9.9v9.9c0,0.3,0.1,0.6,0.3,0.8c0.1,0.1,0.1,0.2,0.2,0.3 l6.7,6.7C16.9,23.7,14.8,24.5,12.5,24.5z M20.3,20.6l-4.9-4.9h7C22.1,17.6,21.4,19.3,20.3,20.6z M15.4,0v11.2h11.2 C26.6,5,21.6,0,15.4,0z M17.9,2.9c2.8,0.8,5,3.1,5.9,5.9h-5.9V2.9z"
	]
};

export const swiDatastudioConnector = {
	prefix: "swi",
	iconName: "datastudio-connector",
	icon: [32, 22, [], null, "M29.6,10.7H15.2h-1H-0.1C8.5,9,1.2,0.5,1.2,0.5h13h1h13.1C28.3,0.5,21,9,29.6,10.7z"]
};
